import eBaseEventTypes from 'Engine/enums/eBaseEventTypes';
export default {
  EET_SHOW_WIN_STATE__START: 'stateStart:showBigWinState',
  EET_STOP_WIN_STATE__START: 'stateEnd:showBigWinState',
  EET_BIG_WIN__SKIP_COMPLETED: 'bigWinContainer:nextState', //
  EET_BIG_WIN__SKIP: 'bigWinContainer:stopState',
  EET_STOP_WIN_STATE__END: `stateEnd:stopWinState`,
  ...eBaseEventTypes
}
